import { IPartialTheme, IStyleSet } from "@fluentui/react/lib/Styling"
import { IStyleFunctionOrObject } from "@fluentui/react/lib/Utilities"

import { IBorderLayoutStyles } from "./BorderLayout.types"

export const BorderLayoutStyles: IStyleFunctionOrObject<
    IPartialTheme,
    IStyleSet<IBorderLayoutStyles>
> = (theme: IPartialTheme) => ({
    vertical: {
        width: "3px",
        backgroundColor: theme.semanticColors?.bodyBackgroundHovered,
        cursor: "col-resize",
        selectors: {
            ":hover": { backgroundColor: theme.palette?.themePrimary }
        }
    },
    horizontal: {
        height: "3px",
        backgroundColor: theme.semanticColors?.bodyBackgroundHovered,
        cursor: "row-resize",
        selectors: {
            ":hover": { backgroundColor: theme.palette?.themePrimary }
        }
    }
})
